import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { isNullOrUndefined } from 'util';

import { ChatService } from '../chat-service';
import { ChatDiscussion } from '../models/chat-discussion';
import { ChatMessage, ChatMessages } from '../models/chat-message';
import { ChatUser } from '../models/chat-user';

@Component({
  selector: 'maintenance-chat-dialog',
  templateUrl: './maintenance-chat-dialog.component.html',
  styleUrls: ['./maintenance-chat-dialog.component.scss']
})
export class MaintenanceChatDialogComponent implements OnInit, OnDestroy {
  @Input() request: any; // The maintenance request

  @Output() markedAsRead: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('messageContainer') messageContainer: ElementRef<HTMLDivElement>;
  chat: ChatDiscussion;

  messages: ChatMessages = [];
  newMessage = '';
  user: ChatUser;
  otherUser: ChatUser = new ChatUser();

  pollTimer: NodeJS.Timer;

  constructor(public bsModalRef: BsModalRef,
    private readonly chatService: ChatService) {
  }

  public ngOnInit(): void {
    this.setCurrentUserInformation();
    this.chat = this.request.discussion;

    this.initializeMessages();
    this.markMessagesAsRead();
    this.startPolling();

    this.scrollToBottom(true);
  }

  /**
   * This polling should be eventually replaced by websockets
   */
  private startPolling() {
    this.getUpdatedDiscussion();
  }

  public ngOnDestroy(): void {
    clearTimeout(this.pollTimer);
  }

  getUpdatedDiscussion(): void {
    this.chatService.fetchDiscussion(this.request.id).subscribe((discussion: ChatDiscussion) => {
      this.chat = discussion;
      this.initializeMessages(discussion.messages);

      // 'Update' the discussion if there are new messages
      this.pollTimer = setTimeout(() => {
        this.getUpdatedDiscussion();
      }, 5000)
    })
  }

  scrollToBottom(alwaysScroll: boolean = false): void {
    setTimeout(() => {
      const el = this.messageContainer.nativeElement;

      const scrollPos = el.scrollTop + el.clientHeight;
      const scrollHeight = el.scrollHeight;
      const percentage = scrollPos / scrollHeight * 100;

      if (alwaysScroll || percentage > 90) {
        el.scrollTop = el.scrollHeight;
      }
    })

  }

  private initializeMessages(messages?: ChatMessages): void {

    if (!isNullOrUndefined(this.chat) && this.chat.messages.length > 0) {

      if (!isNullOrUndefined(messages)) {
        const newMessages = messages.filter(msg => this.messages.findIndex(_msg => _msg.id === msg.id) === -1)
        if (newMessages.length > 0) {
          this.scrollToBottom();
        }
      }
      this.messages = [...this.chat.messages];
    }
  }

  private setCurrentUserInformation(): void {
    const data = JSON.parse(localStorage.getItem('userData'));

    this.user = new ChatUser({
      id: data.id,
      username: data.email_id,
      name: data.first_name
    })
  }

  sendMessage(): void {
    if (this.newMessage.trim() === '') {
      return;
    }

    try {
      this.chatService.createChatMessage(this.request.id, this.newMessage).subscribe((response) => {
        if (!isNullOrUndefined(response) && response.status === 200) {
          var msg: ChatMessage = new ChatMessage({
            text: this.newMessage,
            sender_id: this.user.id,
            id: this.messages[this.messages.length - 1].id + 1 // This is not assured to be the correct id...
          });

          this.messages.push(msg);
          this.newMessage = '';

          this.scrollToBottom(true);

          this.markMessagesAsRead();
        } else {
          throw new Error('Could not send chat message');
        }
      });

    } catch (err) {
      console.error(err);
    }
  }

  private markMessagesAsRead() {
    this.chatService.markAsRead(this.request.id).subscribe(() => {
      this.messages.forEach(msg => msg.read = 1);
      this.markedAsRead.emit(this.request.id);
    });
  }

  public onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && event.ctrlKey) {
      this.sendMessage();
    }
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  trackByFn(index, item) {
    return index; // or item.id
  }
}
